import type { TFunction } from 'i18next';
import { getButtonsCancelOk } from 'context/helpers/helperModalContext';
import { selectStylesLigth } from 'utils/helpers/structs/selectStyles';
import type { SelectOption } from '../../types';
import VendorFilterDlgBody from '../VendorFilterDlgBody';

type ShowDlg = (params: Record<string, unknown> | false) => void;

interface OpenVendorFilterDlgParams {
    showDlg: ShowDlg;
    t: TFunction;
    initialVendorId: number | null;
    vendorOptions: SelectOption[];
    selectTheme: typeof selectStylesLigth;
    onApply: (vendorId: number | null) => void;
}

export const openVendorFilterDlg = ({
    showDlg,
    t,
    initialVendorId,
    vendorOptions,
    selectTheme,
    onApply,
}: OpenVendorFilterDlgParams) => {
    let draftVendorId: number | null = initialVendorId;

    const buttons = [...getButtonsCancelOk(t)] as Array<{
        title: string;
        variant: string;
        handleClick?: () => void;
    }>;
    buttons[1].handleClick = () => {
        const normalized =
            draftVendorId != null && Number.isFinite(draftVendorId) && draftVendorId > 0
                ? draftVendorId
                : null;
        onApply(normalized);
        showDlg(false);
    };

    showDlg({
        title: t('selectVendorFilterTitle'),
        type: 'confirm',
        buttons,
        idFirstFocus: 'products-select-vendor-filter',
        text: (
            <VendorFilterDlgBody
                initialId={draftVendorId}
                vendorOptions={vendorOptions}
                selectTheme={selectTheme}
                label={t('selectVendorFilterLabel')}
                placeholder={t('selectAllVendors')}
                hint={t('selectVendorFilterHint')}
                onChange={(vendorId) => {
                    draftVendorId = vendorId;
                }}
            />
        ),
    });
};
